import { Card, Cell, Spacer } from '@vinted/web-ui';
import { useSelector } from 'react-redux';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import FirstColumn from './FirstColumn';
import SecondColumn from './SecondColumn';
import ThirdColumn from './ThirdColumn';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const AboutPanel = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const isForumDisabled = useSelector(getIsFeatureSwitchEnabled('disable_forum_web'));

  const renderBody = () => /*#__PURE__*/_jsx("div", {
    className: "catalog-dropdown__content",
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-flexbox u-nowrap",
      children: [/*#__PURE__*/_jsx(FirstColumn, {
        isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(SecondColumn, {
        impressumUrl: impressumUrl,
        isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
      }), !isForumDisabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(ThirdColumn, {})]
      })]
    })
  });

  return /*#__PURE__*/_jsx(Card, {
    styling: Card.Styling.Elevated,
    children: /*#__PURE__*/_jsx("div", {
      className: "u-overflow-auto",
      children: /*#__PURE__*/_jsx(Cell, {
        body: renderBody()
      })
    })
  });
};

export default AboutPanel;